<form name="frmTelco"  style="margin-top:-1.5%;">
    <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;height:55vw;background-color: #f4f8f6;">
        <div class="panel panel-heading" style="padding-left: 15px;padding-top: 0px;padding-bottom: 0px;background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white; ">
            Telco Provider Details</div>
        <div class="panel-body">
            <div class="activity-box" *ngIf="dataLoader"><div class="loading-spiner"><img src="assets/img/loadingVer.gif" class="load"/></div></div>
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-12">
                    <div class="col-sm-3 formdivcaptions" style="width:auto;margin-top:30px;">
                        <label style="color:rgb(65, 0, 0);font-weight:bold;margin-right:30px;">Device Type </label>
                        <label  *ngFor="let DeviceType of DeviceTypeList">
                            <input type="radio" name="radioDeviceType" value="{{DeviceType.name}}" (change)="DeviceTypeEvent($event)" /><label>&nbsp;{{DeviceType.name}}&nbsp; </label>
                        </label>
                    </div>
                    <div class="col-sm-12" style="display:none" id="showMsg">
                        <label
                            style="color: darkslateblue; font-weight: bold; font-size: 15px; ">{{ErrorMessage}}</label>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div id="divTelcoCommon" style="display:none;">
                        <div class="col-sm-3 formDivCaptions">
                            <label for="dlstTelco">Telco Name</label>
                            <select class="form-control col-sm-4" id="dlstTelco" name="dlstTelco"> 
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let T of TelcoList">{{T.telcoName}}</option>
                            </select>
                        </div>
                        <div class="col-sm-3 formDivCaptions">
                            <label for="dlstCountry">Country</label>
                            <select class="form-control col-sm-4" id="dlstCountry" name="dlstCountry">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let C of Countries">{{C.Country}}</option>
                            </select>
                        </div>
                        <div class="col-sm-3 formDivCaptions">
                            <label for="txtdlstDeviceName">Device Name</label>
                            <input type="text" id="txtdlstDeviceName" name="txtdlstDeviceName" [(ngModel)]="dlstDeviceName" class="form-control" (change)="GetSearchDeviceName()" />
                            <div  *ngIf="showRecEIdlistbox" style="margin-top:-4%;">
                              <select class="form-control" id="enterpriseIDSelect" name="enterpriseIDSelect" multiple [(ngModel)]="dlstDeviceName" (click)="PostSearchDeviceName()" style="margin-top:4%;">
                                    <option *ngFor="let item of SelectedEnterpriseIDList1">{{item}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="Country=='India'" class="col-sm-12 formdivcaptions" style="margin-top:2%;margin-left:-3% ;">
                        <div align="center" id="divTelcoSubmit" style="display:none;">
                            <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span>Search</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="btnExcelExport" class="btn btn-default btn-group-sm Button1" (click)="ExportToBulkExcel()"><span class="glyphicon glyphicon-export" aria-hidden="true"></span> Export to Excel</button>
                        </div>
                    </div>
                    <div *ngIf="Country!='India'" class="col-sm-3 formdivcaptions" style="margin-top:2%;margin-left:-3% ;">
                        <div align="center" id="divTelcoSubmit" style="display:none;">
                            <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span>Search</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" id="divTelcoDetails" style="display:none;">
            <div style="margin-left: 20px; margin-right: 20px; margin-top:-2%;overflow:scroll; height:450px;width:90%">
                <br />
                <table id="CallrateDetails" class="table table-bordered" border="1" style="margin-left:2.7%;width:97.3%;font-size:13px;">
                    <tr style="color:white;background: #8064A2; height:25px; background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                        <th style="display: none;">S.No</th>
                        <th><label style="width:50px; margin-top: 7%;  text-align:center;">
                            <input type='checkbox' [(ngModel)]="selectedAll" (click)="checkAll('Telco', $event.target.checked)" id="selectedAll" name="selectedAll" title="selectedAll"/></label> </th>
                        <th style="text-align: center;"></th>
                        <th style="text-align: center;">Country</th>
                        <th style="text-align: center;">Telco Name</th>
                        <th style="text-align: center;">Device Name</th>
                        <th style="text-align: center;">Rate Name</th>
                     </tr>
                    <tbody *ngFor="let Telco of successfulData.Telcos">
                        <tr *ngIf="Telco.telcoRateId != this.successfulData.selected.telcoRateId">
                            <td style="display:none">{{Telco.telcoRateId}}</td>
                            <td><label style="width:30px; text-align :center;"><input type='checkbox' [(ngModel)]="Telco.checked" id="singlecheck_{{Telco.telcoRateId}}" name="singlecheck" title="singlecheck_{{Telco.telcoRateId}}"/></label> </td>
                            <td>
                                <img src="assets/img/Edit-icon.png" title="Edit" (click)="EditTelco(Telco)" />
                                <img src="assets/img/Delete.png" title="Delete" (click)="DeleteTelco(Telco)" />
                            </td>
                            <td>{{Telco.Country}}</td>
                            <td>{{Telco.telcoName}}</td>
                            <td>{{Telco.deviceName}}</td>
                            <td>{{Telco.CallRateName}}</td>
                        </tr>
                        <tr *ngIf="Telco.telcoRateId === this.successfulData.selected.telcoRateId">
                            <td></td>
                            <td> <img src="assets/img/Add.png" (click)="TelcoUpdate(Telco)" title="Update" />
                                 <img src="assets/img/Cancel.jpg" (click)="reset()" title="Cancel" />
                            </td>
                            <td> {{successfulData.selected.Country}} </td>
                            <td> {{successfulData.selected.telcoName}} </td>
                            <td> {{successfulData.selected.deviceName}} </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="dlstCallRateName" name="dlstCallRateName" [(ngModel)]="successfulData.selected.CallRateName" >
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let Rate of RateList" value="{{Rate.CallRateName}}">{{Rate.CallRateName}}</option>
                                </select>
                            </td>
                            </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td>
                                <button id="btnAddProjectMemberAssignment" type="button"
                                    class="btn btn-default btn-group-sm Button1" (click)="TelcoAdd()">
                                    <span class="fa fa-check-circle" aria-hidden="true">
                                    </span> Add
                                </button>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                     <span>*</span>
                                </div>
                                <select class="form-control col-sm-4" id="grdfCountries" name="grdfCountries" [(ngModel)]="TelcoDetails.Country" aria-labelledby="grdfCountries">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries">{{C.Country}}</option>
                                </select>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;"
                                    class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" class="form-control" id="grdfTelco" name="grdfTelco" [(ngModel)]="TelcoDetails.telcoName" placeholder="Telco Name"/>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;"
                                    class="col-md-1">
                                     <span>*</span>
                                </div>
                                <input type="text" id="txtDeviceName" name="txtDeviceName" [(ngModel)]="TelcoDetails.deviceName" class="form-control" (change)="GetDeviceName()" placeholder="Device Name"/>
                                <div  *ngIf="showRecEIdlistbox" style="margin-top:-4%;">
                                    <!-- <select class="form-control" id="enterpriseIDSelect" name="enterpriseIDSelect" multiple  [(ngModel)]="TelcoDetails.deviceName"                                     
                                    *ngFor="let item of SelectedEnterpriseIDList" (click)="PostDeviceName()" style="margin-top:4%;">{{item}}
                                </select> -->
                                <select class="form-control" id="enterpriseIDSelect" name="enterpriseIDSelect" multiple [(ngModel)]="deviceName" (click)="PostDeviceName()" style="margin-top:4%;">
                                    <option *ngFor="let item of SelectedEnterpriseIDList">{{item}}</option>
                                </select>
                                </div>
                            </td>
                            <td>
                                <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;"
                                    class="col-md-1">
                                     <span>*</span>
                                </div>
                               <div><ng-multiselect-dropdown placeholder ="Select" id="gdrfCallRateName" name="gdrfCallRateName" [data]="dlstfCallRateName" [(ngModel)]="CallRateName" [settings]="dropDownSettings"></ng-multiselect-dropdown></div>
                            </td>
                        </tr>
                        <!-- <tr>
                            <td colspan="11" style="text-align: center;">
                                <paginator></paginator>
                            </td>
                        </tr> -->
                        <tr>
                            <td colspan="11" style="text-align: center;">
                                <!-- pager -->
                                <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                        </a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                                        <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                    </li>
                                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                        <a (click)="setPage(page)">{{page}}</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                        <a (click)="setPage(pager.startPage + 5)">...</a>
                                    </li>
                                    <li *ngIf="(pager.totalPages - pager.startPage) > 5" >
                                        <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                    </li>
                                    
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                    </li>
                                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                        <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div id="AlertForAccess" style="display:none;">
            <div class="row" style="padding-top:-20%">
                <div class="col-sm-12" style="margin-left:5%;">
                    <h4 style="color:red;">
                        Access Not Available.Please refer User Guidelines section for any access or tool issue.
                    </h4>
                </div>
            </div>
        </div>
    </div>
</form>